import React from 'react';
import type { Question } from '../types';

interface PreviewControlsProps {
  question: Question;
  examQuestions: Question[];
  onExamQuestionsChange: (questions: Question[]) => void;
  onHasWidthChangesChange: (hasChanges: boolean) => void;
}

export default function PreviewControls({
  question,
  examQuestions,
  onExamQuestionsChange,
  onHasWidthChangesChange
}: PreviewControlsProps) {
  const currentLayout = (question as any)?.titleImageLayout || 'auto';
  const hasTitleImages = question?.titleImages && question.titleImages.length > 0 && !question?.title?.includes('<img');
  const hasTitleContentImages = question?.title?.includes('<img');

  if (!(hasTitleImages || hasTitleContentImages)) return null;

  const updateLayout = (newLayout: string) => {
    const newQuestions = examQuestions.map(q =>
      q.id === question.id ? { ...q, titleImageLayout: newLayout } : q
    );
    onExamQuestionsChange(newQuestions);
    onHasWidthChangesChange(true);
  };

  return (
    <div className="flex flex-row gap-1 bg-white/90 backdrop-blur-sm rounded-lg px-2 py-1 shadow-sm border border-gray-200">
      <button
        onClick={() => updateLayout('auto')}
        className={`p-1.5 rounded transition-colors ${currentLayout === 'auto' ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}
        title="自动布局"
      >
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <rect x="14" y="14" width="7" height="7" rx="1" />
        </svg>
      </button>
      <button
        onClick={() => updateLayout('cols1')}
        className={`p-1.5 rounded transition-colors ${currentLayout === 'cols1' ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}
        title="每行1图"
      >
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="4" y="3" width="16" height="5" rx="1" />
          <rect x="4" y="10" width="16" height="5" rx="1" />
          <rect x="4" y="17" width="16" height="5" rx="1" />
        </svg>
      </button>
      <button
        onClick={() => updateLayout('cols2')}
        className={`p-1.5 rounded transition-colors ${currentLayout === 'cols2' ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}
        title="每行2图"
      >
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="8" height="8" rx="1" />
          <rect x="13" y="3" width="8" height="8" rx="1" />
          <rect x="3" y="13" width="8" height="8" rx="1" />
          <rect x="13" y="13" width="8" height="8" rx="1" />
        </svg>
      </button>
      <button
        onClick={() => updateLayout('cols3')}
        className={`p-1.5 rounded transition-colors ${currentLayout === 'cols3' ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}
        title="每行3图"
      >
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="5" height="5" rx="1" />
          <rect x="9" y="3" width="5" height="5" rx="1" />
          <rect x="16" y="3" width="5" height="5" rx="1" />
          <rect x="2" y="10" width="5" height="5" rx="1" />
          <rect x="9" y="10" width="5" height="5" rx="1" />
          <rect x="16" y="10" width="5" height="5" rx="1" />
        </svg>
      </button>
      <button
        onClick={() => updateLayout('cols4')}
        className={`p-1.5 rounded transition-colors ${currentLayout === 'cols4' ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}
        title="每行4图"
      >
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="4" height="4" rx="1" />
          <rect x="7" y="3" width="4" height="4" rx="1" />
          <rect x="12" y="3" width="4" height="4" rx="1" />
          <rect x="17" y="3" width="4" height="4" rx="1" />
          <rect x="2" y="9" width="4" height="4" rx="1" />
          <rect x="7" y="9" width="4" height="4" rx="1" />
          <rect x="12" y="9" width="4" height="4" rx="1" />
          <rect x="17" y="9" width="4" height="4" rx="1" />
        </svg>
      </button>
    </div>
  );
}
